
import {Carousel} from 'react-bootstrap'
import '../../App.css' ;
import {Link} from 'react-router-dom';
import AOS from 'aos';
import Price from '../../image/Price.jpg'
import Mockup from '../../image/Mockup.png'
import enviroment from '../../image/enviroment.png'
import slide3 from '../../image/slide3.jpg'
import slide4 from '../../image/slide4.jpg'
import slide5 from '../../image/slide5.jpg'
import TechMang from '../../image/TechMang.jpg'
import mang from '../../image/mang.png'
import ModeIN from '../../image/ModeIN.jpg'
import MAINT from '../../image/MAINT.jpg'
import Renewableenergy from '../../image/Renewableenergy.jpg'





function Home(){
   
    AOS.init();
                
    return(
        <div className='home'>
            
            <div className="container carousel"> 
            <Carousel>
            <Carousel.Item  >
                <img
                className="d-block w-100"
                src="https://d3hnfqimznafg0.cloudfront.net/images/Article_Images/ImageForArticle_980(1).jpg"
                alt="First slide"
                style={{height: "700px"}}
                />
                <Carousel.Caption >
                <h3 > MPEMI ... Green and sustainable solutions</h3>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item  >
                <img
                className="d-block w-100"
                src={enviroment}
                alt="Second slide"
                style={{height: "700px"}}
                />
                <Carousel.Caption>
                <h3>MPEMI ... Smart solutions to save Environment</h3>
                
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item >
                <img
                className="d-block w-100"
                src={slide3}
                alt="Third slide"
                style={{height: "700px"}}
                />
                <Carousel.Caption>
                <h3>MPEMI ... Innovative ways to enhance your efficiency</h3>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item >
                <img
                className="d-block w-100"
                src={slide4}
                alt="Third slide"
                style={{height: "700px"}}
                />
                <Carousel.Caption>
                <h3>MPEMI ... Customized solutions for industry</h3>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item >
                <img
                className="d-block w-100"
                src={slide5}
                alt="Third slide"
                style={{height: "700px"}}
                />
                <Carousel.Caption>
                <h3>MPEMI ... Caoching to better fulfill your customer's needs</h3>
                </Carousel.Caption>
            </Carousel.Item>
            </Carousel>
            </div>

            <div className="container" style={{padding:" 0 30px"}}>
                <div className="row">
                    <div className="col-md-4 d-flex align-items-center justify-content-center bg-secondary mb-4 mb-lg-0 "  style={{height: "100px" ,color:"#FFD662"}}>
                    <div className="d-inline-flex">
                    <i className="fa fa-2x fa-map-marker-alt text-white m-0 mr-3"></i>
                    <div className="d-flex flex-column" >
                    <h5 className="text-white font-weight-medium">Our Location</h5>
                    <p className="m-0 text-white">Tunis, tunisia <br/> Ouagadougou , Burkina Faso</p>
                    </div>
                    </div>
                    </div>
                    <div className="col-md-4 d-flex align-items-center justify-content-center bg-primary mb-4 mb-lg-0" style={{height: "100px"}}>
                    <div className="d-inline-flex text-left">
                    <i className="fa fa-2x fa-envelope text-white m-0 mr-3"></i>
                    <div className="d-flex flex-column">
                    <h5 className="text-white font-weight-medium">Email Us</h5>
                    <p className="m-0 text-white" >pemi.tunisia@gmail.com</p>
                    </div>
                    </div>
                    </div>
                    <div className="col-md-4 d-flex align-items-center justify-content-center bg-secondary mb-4 mb-lg-0"  style={{height: "100px",hover:"#FFD662 "}}>
                    <div className="d-inline-flex text-left">
                    <i className="fa fa-2x fa-phone-alt text-white m-0 mr-3"></i>
                    <div className="d-flex flex-column" >
                    <h5 className="text-white font-weight-medium" >Call Us</h5>
                    <p className="m-0 text-white" >+216 53 266 284 <br/> +216 95 531 748 </p>
                    </div>
                    </div>
                    </div>
                </div>
            </div>



            <div className="about">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5 col-md-6">
                            <div data-aos={"fade-up-right"} className="about-img">
                                <img src={TechMang} style={{height: "400px"}} alt="imae"/>
                            </div>
                        </div>
                        <div className="col-lg-7 col-md-6">
                            <div data-aos={"fade-up-left"} className="about-text">
                                <h2 style={{textAlign:"center"}} > Technical and Management Activities</h2>
                                <p>
                                MPEMI  is a company specializing in the  provision of Engineering, operation and maintenance services , primarily focused on the renewables sector as well as Environment applications. As an Operation & Maintenance market leader, MPEMI operates not only in Tunisia, but also in several african countries like Burkina Faso, Ivory Coast , Libya and Morocco .                                </p>
                                <p>
                                Our team helps companies of all sizes build sustainable management systems that comply with ISO requirements. We work with your organization to build upon the foundational activites already at work, enabling you to save time, effort and resources. We're focused on  LEAN & agile systems that continue to produce results year-after-year, tailored specifically to your business.      
                               </p>
                               <p>
                               We perform audit activities on behalf of our clients (internal, external, supplier audit)   ISO 9001,ISO 17025, ISO 50001, ISO 45001 and IATF 16949.


                               </p>
                             
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="service">
                <div className="container">
                    <div className="section-header">
                        <p></p>
                        <h2>Our Services</h2>
                    </div>
                    <div className="row">
                        <div data-aos={"flip-left"} data-aos-easing={"ease-out-cubic"} data-aos-duration={"2000"}  className="col-lg-3 col-md-6">
                            <div className="service-item">
                                <img src={MAINT} alt="Service"/>
                                <h3>Maintenance</h3>
                                <p>
                                MPEMI Service is a customer-oriented company, focused on providing excellent service based on ongoing collaboration. This starts by identifying and understanding each customer's specific needs, thereby ensuring maximum productivity and, above all, in optimal conditions in order to extend the plant's operating life as much as possible, through the use of state-of-the-art predictive maintenance technology.
                                </p>
                                <Link className="btnn" to="/maintenance">Learn More</Link>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div data-aos={"flip-left"} data-aos-easing={"ease-out-cubic"} data-aos-duration={"2000"}  className="service-item">
                                <img src={Renewableenergy} alt="Service"/>
                                <h3>Renewable energy & Environment</h3>
                                <p>
                                Thanks to its extensive experience, MPEMI  has become a reputable leader, trusted by the key actors in the Environment & Energy sector. MPEMI deliver multi-technology services with a multi-brand scope, the company provides innovation throughout the entire value chain.
                                </p>
                                <Link className="btnn" to="/energie-renouvable">Learn More</Link>
                            </div>
                        </div>
                        <div data-aos={"flip-left"} data-aos-easing={"ease-out-cubic"} data-aos-duration={"2000"} className="col-lg-3 col-md-6">
                            <div className="service-item">
                                <img src={mang} alt="Service"/>
                                <h3>Management</h3>
                                <p>
                                We offer the complete "package" around Management systems. MPEMI accompany you all the way from the initial idea through the implementation and training up to certification ...
                                </p>
                                <Link className="btnn" to="/management">Learn More</Link>
                            </div>
                        </div>
                        <div data-aos={"flip-left"} data-aos-easing={"ease-out-cubic"} data-aos-duration={"2000"}  className="col-lg-3 col-md-6">
                            <div className="service-item">
                                <img src={ModeIN} alt="Service"/>
                                <h3>How We Act</h3>
                                <p>
                                STUDIES, DIAGNOSTICS, RECOMMENDATIONS, INSTALLATION, COMMISSIONING, MAINTENANCE & TRAINING .
                                </p>
                                <Link className="btnn" to="/modes-d-intervention">Learn More</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            
            <div className="feature">
                <div className="container">
                    <div className="row">
                        <div data-aos={"fade-up"} data-aos-duration={"3000"} className="col-md-5">
                            <div className="section-header left">
                                <p>Why Choose Us</p>
                                <h2>Enjoy These and Other Advantages When You Partner with Us</h2>
                            </div>
                            <p>
                            From our unwavering commitment to honesty and integrity to reliability, punctuality, cleanliness, and transparency, we want you to feel completely confident that you have partnered with the best of the best.                                    
                            </p>
                            <p>
                            Our team of project managers,  consultants, designers, engineers, installers, and customer care specialists work together to make the entire process exciting and stress-free. We work with you to ensure we’re not only meeting, but also exceeding your expectations along each and every step of the way. We won’t settle for anything less than the best, and neither should you. Here are some of the benefits you can look forward to when you choose us.                            </p>
                            <Link className="btn" to="/contact">Contact Us</Link>
                        </div>
                        <div className="col-md-7">
                            <div  data-aos={"zoom-in"} className="row align-items-center feature-item">
                                <div className="col-5">
                                    <img src={Mockup} alt="Feature"/>
                                </div>
                                <div className="col-7">
                                    <h3>Experts Workers </h3>
                                    <p>
                                    we are committed to excellence in everything we do.  Each member of our team shares the values that make MPEMI exceptional.</p>
                                </div>
                            </div>
                            <div data-aos={"zoom-in"} className="row align-items-center feature-item">
                                <div className="col-5">
                                <img src={Price} alt="QSl" />                                </div>
                                <div className="col-7">
                                    <h3>Reasonable Prices</h3>
                                    <p>
                                    We offer competitive  prices.
                                    </p>
                                </div>
                            </div>
                            <div data-aos={"zoom-in"} className="row align-items-center feature-item">
                                <div className="col-5">
                                    <img src="http://thequickservice.com/images/Logo.jpg" alt="Feature"/>
                                </div>
                                <div className="col-7">
                                    <h3>Quick & Best Services</h3>
                                    <p>
                                    We want to ensure that your expectations are met and that your entire experience with MPEMI is a positive one.                      
                                   </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>

    );
}
export default Home ;